<div
  class="field"
  [ngClass]="{
    'is-horizontal':
      !(row.get('isMultiple') && row.get('isPropertyType')) && !isVertical,
    'is-vertical': isVertical,
    'is-single': !row.get('isMultiple') && row.get('isPropertyType')
  }"
>
  <label class="label" *ngIf="!row.get('isPropertyType')">
    <span [translationEditableDirective]="row.get('label')">{{
      row.get('label')
    }}</span>
  </label>

  <div *ngIf="isReadonly" class="control">
    <div *ngIf="row.get('isPropertyType')">
      <div
        *ngFor="let row of propertyTypeReadonly"
        class="readonly-property-type"
      >
        <div>
          <strong>{{ row.label }}: </strong>
          <span>{{ row.floors }} {{ 'FLOORS' | translate }}</span>
        </div>

        <div *ngFor="let child of childrenReadonly(row.label)">
          <strong>{{ child.label }}: </strong>
          <span>{{ child.value }} {{ child.percentage }}%</span>
        </div>
      </div>
    </div>
    <span
      *ngIf="
        row.get('type') === 'input' ||
        (row.get('type') === 'select' && !row.get('isPropertyType'))
      "
    >
      {{ value }}</span
    >
    <!-- <span
      class="pl-1"
      style="text-transform: lowercase"
      *ngIf="row.get('isMultiple') && row.get('isPropertyType')"
      translationEditableDirective="FLOORS"
      >{{ 'FLOORS' | translate }}</span
    > -->
  </div>

  <div class="control" *ngIf="row.get('type') === 'input' && !isReadonly">
    <input
      class="input is-small"
      (input)="handleFieldChange($event)"
      [name]="row.get('name')"
      [value]="value || ''"
      type="text"
    />
  </div>

  <div class="control" *ngIf="row.get('type') === 'select' && !isReadonly">
    <ng-select
      *ngIf="
        (!row.get('isMultiple') && row.get('isPropertyType')) ||
        !row.get('isPropertyType')
      "
      [items]="options"
      class="is-small"
      [multiple]="row.get('isMultiple')"
      [closeOnSelect]="!row.get('isMultiple')"
      [ngModel]="
        !row.get('isMultiple') && row.get('isPropertyType')
          ? getSingleValue(value)
          : value
      "
      (change)="handleSelectChange({ option: $event, name: row.get('name') })"
      [ngModelOptions]="{ standalone: true }"
      [title]="isImmutable(value) ? value.get('label') : value ?? ''"
    >
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label">{{
          isImmutable(item) ? item.get('label') : item
        }}</span>
        <span
          class="ng-value-icon right"
          (click)="clear(item)"
          aria-hidden="true"
          >×</span
        >
      </ng-template>

      <ng-template
        ng-option-tmp
        let-item="item"
        let-item$="item$"
        let-index="index"
      >
        <span [title]="isImmutable(item) ? item.get('label') : item">{{
          isImmutable(item) ? item.get('label') : item
        }}</span>
      </ng-template>
    </ng-select>
    <form-preview-multiselect
      [row]="row"
      [options]="row.get('options')"
      (onSelect)="handleSelectChange({ option: $event, name: row.get('name') })"
      (onInput)="handleSelectInput({ input: $event, name: row.get('name') })"
      *ngIf="row.get('isMultiple') && row.get('isPropertyType')"
      [value]="value"
      (onGroupSelect)="handleSelectChange($event)"
      (onGroupSelectInput)="handleSelectInput($event)"
      (onGroupInput)="handleFieldChange($event)"
      [values]="values"
      [activeForm]="activeForm"
    ></form-preview-multiselect>
  </div>

  <ng-container
    *ngIf="
      !row.get('isMultiple') &&
      row.get('isPropertyType') &&
      row.get('type') === 'select' &&
      !isReadonly
    "
  >
    <div class="is-flex is-justify-content-end">
      <span translationEditableDirective="FLOORS" style="font-size: 14px">{{
        'FLOORS' | translate
      }}</span
      ><span style="font-size: 14px" class="mr-1">:</span>
      <number-input
        style="width: 60px"
        inputClass="input is-xsmall"
        [name]="getSingleValue(value)"
        step="0.01"
        [disabled]="!value && !previewValue[row.get('name')]"
        [value]="getSingleFloors(value)"
        (input)="
          handleSelectInput({
            input: {
              label: $event?.target?.name,
              value: $event?.target?.value
            },
            name: row.get('name')
          })
        "
      />
    </div>
  </ng-container>

  <span *ngIf="!row.get('isPropertyType') && percentage !== undefined"
    >{{ percentage }}%</span
  >
</div>

<div
  *ngIf="
    !row.get('isMultiple') &&
    row.get('isPropertyType') &&
    row.get('type') === 'select' &&
    !isReadonly
  "
  class="form-property-group mt-3"
>
  <h6
    class="form-property-group-title"
    *ngIf="
      showChildren(row, getSelectedOption) &&
      row.get('isPropertyType') &&
      getSelectedOption.get('children').size
    "
    [translationEditableDirective]="getSelectedOption.get('label')"
  >
    {{ getSelectedOption.get('label') | translate }}
  </h6>

  <ng-container
    *ngIf="
      showChildren(row, getSelectedOption) &&
      getSelectedOption.get('children').size
    "
  >
    <div *ngFor="let element of getSelectedOption.get('children')">
      <form-preview-element
        [isReadonly]="isReadonly"
        *ngIf="showChildren(row, getSelectedOption)"
        [row]="element"
        [values]="values"
        [activeForm]="activeForm"
        (onSelect)="handleSelectChange($event)"
        (onInput)="handleFieldChange($event)"
        [isVertical]="true"
      >
      </form-preview-element>
    </div>
  </ng-container>
</div>
